import React from 'react'

const Parts = () => {
  return (
    <div>Parts</div>
  )
}

export default Parts